import React from 'react'

const SectionHeader = ({ children }) => {

    return (
        <div
            style={{
                borderTop: '1px solid rgb(62, 99, 250)',
                paddingTop: '5px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-around'
            }}
        >
            <strong>{children}</strong>
        </div>
    )
}

export default SectionHeader